import React from 'react';
import { HomeFooter, Copyright } from 'components/organisms';
import PropTypes from 'prop-types';
import userFlowTheme from 'theme/HomeTheme';
import { ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { reCaptchaSiteKeys } from 'common/constants';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: 'calc(100vh - 212px)',
    [theme.breakpoints.up('md')]: {
      minHeight: 'calc(100vh - 148px)'
    }
  }
}));

const Minimal = (props) => {
  const classes = useStyles();
  const { children } = props;
  const shouldUseProdReCaptcha = window.location.hostname.includes(
    'launder-it'
  );
  const currentReCaptchaKey = shouldUseProdReCaptcha
    ? reCaptchaSiteKeys.prod
    : reCaptchaSiteKeys.dev;

  return (
    <ThemeProvider theme={userFlowTheme}>
      <GoogleReCaptchaProvider reCaptchaKey={currentReCaptchaKey}>
        <main className={classes.content}>{children}</main>
      </GoogleReCaptchaProvider>
      <HomeFooter />
      <Copyright />
    </ThemeProvider>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;
